import React from 'react';
import styled from '@emotion/styled';
import scale from '../../core/utilities/scale';
import { Colors } from '../constants';

export interface CTACardProps {
  title: React.ReactNode;
  children?: React.ReactNode;
}

export default function CTACard({
  title,
  children,
}: CTACardProps): JSX.Element {
  return (
    <Container>
      <Title>{title}</Title>
      <Body>{children}</Body>
    </Container>
  );
}

const Container = styled.div({
  display: 'flex',
  flexDirection: 'column',
  width: scale(677),
  borderRadius: scale(16),
  overflow: 'hidden',
  margin: `0 ${scale(60)}`,
  boxShadow: `${scale(-6)} ${scale(6)} ${scale(8)} 0 rgba(0, 0, 0, 0.2)`,
  background: '#ffffff',
});

const Title = styled.div({
  fontSize: scale(38),
  fontWeight: 700,
  lineHeight: scale(42),
  backgroundColor: Colors.PRIMARY,
  color: '#ffffff',
  padding: `${scale(32)} ${scale(0)}`,
  boxShadow: `${scale(-6)} ${scale(6)} ${scale(8)} 0 rgba(0, 0, 0, 0.2)`,
  textAlign: 'center',
});

const Body = styled.div({
  fontSize: scale(28.8),
  letterSpacing: 0.25,
  lineHeight: scale(43.2),
  color: `rgba(0, 0, 0, 0.8)`,
  padding: `${scale(24)} ${scale(40)} ${scale(40)}`,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: scale(38.4),
});
